"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticSyntheticTokenFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var StaticSyntheticTokenFactory = /** @class */ (function (_super) {
    __extends(StaticSyntheticTokenFactory, _super);
    function StaticSyntheticTokenFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    StaticSyntheticTokenFactory.prototype.deploy = function (_name, _symbol, overrides) {
        return _super.prototype.deploy.call(this, _name, _symbol, overrides || {});
    };
    StaticSyntheticTokenFactory.prototype.getDeployTransaction = function (_name, _symbol, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _name, _symbol, overrides || {});
    };
    StaticSyntheticTokenFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    StaticSyntheticTokenFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    StaticSyntheticTokenFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return StaticSyntheticTokenFactory;
}(contracts_1.ContractFactory));
exports.StaticSyntheticTokenFactory = StaticSyntheticTokenFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "MinterAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "MinterRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "addMinter",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getAllMinters",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "isValidMinter",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "minters",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "mintersArray",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "removeMinter",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbolKey",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transferCollateral",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=StaticSyntheticTokenFactory.js.map